import {RootState} from '../config/types';

export const userFromCode = (state: RootState) => {
  return state!.nutritionists.userFromCode;
};

export const errorUserFromCode = (state: RootState) => {
  return state!.nutritionists.errorGettingUserFromCode;
};
